import {FullGameFetchHandler} from "../../../../../core/handlers/full-game.fetch-handler";
import {EntityMegaHeaderModuleController} from "../../../../../apps/website/modules/entity-mega-header-module/entity-mega-header-module.controller";
import type {GameCenterContainerState} from "../../../models/game-center-container.state";
import {FullGameResponseDomainService} from "../../../../../domain/full-game/services/full-game-response.domain-service";
import {WebsiteModuleState} from "../../../../../apps/website/models/website-module.state";
import {NEW_GAME_CENTER_CONTAINER} from "../../../game-center-container.consts";
import {BaseApiRequestParams} from "../../../../../infrastructure/models/params/base-api-request-params";
import {FullGameRequestParams} from "../../../../../domain/full-game/models/full-game.request-params";
import type {FullGameDataSource} from "../../../../../domain/full-game/models/full-game-data-source";
import {ACTION_TYPES} from "../../../../../core/consts";

export class GameCenterIndexPageFetchHandler extends FullGameFetchHandler {
  controller: EntityMegaHeaderModuleController;
  state: GameCenterContainerState;

  static injectables = [FullGameResponseDomainService, WebsiteModuleState];

  constructor(service: FullGameResponseDomainService, websiteModuleState) {
    super(service);

    this.websiteModuleState = websiteModuleState;
  }

  async onLoaded() {
    await super.onLoaded();

    this.controller.action(NEW_GAME_CENTER_CONTAINER.ACTION_TYPES.fetchCompetition);
    this.action()
  }

  get requestParams(): BaseApiRequestParams {
    const gameId: Number = this.state?.gameId;
    const matchupId: String = this.state?.matchupId;
    const topBookmaker = this.state.appState.topBookmakerId;

    const requestParams: FullGameRequestParams = new FullGameRequestParams(gameId, matchupId, topBookmaker);

    return requestParams;
  }

  async action() {
    this.store.clearDataSource();

    const dataSource: FullGameDataSource = await super.fetch();

    this.controller.action(ACTION_TYPES.populateData, {dataSource}).then(() => {
      this.websiteModuleState.entitiesContext.setGame(dataSource.game);
      this.state.game = dataSource.game;

      this.controller.action(NEW_GAME_CENTER_CONTAINER.ACTION_TYPES.fetchMetadata);
      this.controller.action(NEW_GAME_CENTER_CONTAINER.ACTION_TYPES.breadcrumbsHandler, {entity: dataSource.game})
    });

    return dataSource;
  }

  async onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const isMatchDetailsChanged: Boolean = prevProps.match.params.matchDetails !== nextProps.match.params.matchDetails;

    if (isMatchDetailsChanged) {
      await this.action();
    }
  }

  onUnloaded(controller: EntityMegaHeaderModuleController) {
    super.onUnloaded(controller);

    this.websiteModuleState.entitiesContext.setGame(null);
  }
}
